module.exports = {
  init: function () {
    let latticeCookiesURL = window.Urls.latticeCookiesURL;
    let isLatticeEnabled = window.SitePreferences?.isLatticeEnabled;
    if (isLatticeEnabled && latticeCookiesURL) {
      $.ajax({
          url: latticeCookiesURL,
          type: 'post'
      }).done(function (response) {
        if (response && response.success) {
          console.log('Lattice cookies set successfully');
        }
      });
    }
  }
}
